import { useState, useEffect, useRef } from 'react';
import showI from '../img/logo2.png';
import showIDark from '../img/logo2Dark.png';
import { motion } from 'framer-motion';

const Skills = (props) => {
  const [showAll, setShowAll] = useState(false); // State to manage visibility
  const skills = [
    { name: 'HTML', width: '80%' },
    { name: 'CSS', width: '70%' },
    { name: 'Tailwind', width: '85%' },
    { name: 'PHP', width: '65%' },
    { name: 'Laravel', width: '75%' },
    { name: 'JavaScript', width: '90%' },
    { name: 'React', width: '75%' },
    { name: 'MERN Stack', width: '35%' },
    { name: 'Figma', width: '65%' },
  ];

  const visibleSkills = showAll ? skills : skills.slice(0, 4); // Show only 4 or all

  // Refs to hold skill elements
  const skillRefs = useRef([]);

  // Function to check if an element is in view
  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  // Animation control state
  const [animate, setAnimate] = useState(Array(visibleSkills.length).fill(false));

  useEffect(() => {
    const handleScroll = () => {
      skillRefs.current.forEach((ref, index) => {
        if (ref && isInViewport(ref)) {
          setAnimate((prev) => {
            const newAnimate = [...prev];
            newAnimate[index] = true;
            return newAnimate;
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [visibleSkills]);

  return (
    <div className="flex flex-col gap-7 lg:gap-2 md:gap-2">
      {visibleSkills.map((skill, index) => (
        <motion.div
          key={index}
          ref={(el) => (skillRefs.current[index] = el)} // Assigning ref to each skill
          initial={{ opacity: 0, scale: 0.95 }}
          animate={animate[index] ? { opacity: 1, scale: 1 } : {}} // Animate only when in view
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-gray-400 font-medium">{skill.name}</h2>
          <div className="bg-gray-200 h-1.5 rounded-md">
            <motion.div
              className={`h-1.5 rounded-md transition-transform transform hover:scale-105 ${props.darkMode?'bg-orange-600':'bg-purple-800'}`}
              style={{ width: skill.width }}
            ></motion.div>
          </div>
        </motion.div>
      ))}

      {/* Toggle Button */}
      <div className="flex justify-end mt-2"> {/* Aligns the button to the right */}
        <button
          onClick={() => setShowAll(!showAll)} // Toggle skills on click
          className={`border ${props.darkMode?'bg-neutral-900 border-orange-500 hover:bg-neutral-800 transition':'bg-white border-purple-800  hover:bg-gray-100 transition'} px-1 py-1 flex items-center justify-center rounded-lg shadow-lg`}
          style={{ width: '40px' }} 
        >
          <img 
            src={props.darkMode?showIDark:showI}
            alt="Toggle Skills Icon" 
            className="w-6 h-6"
          />
        </button>
      </div>
    </div>
  );
};

export default Skills;
